import ModelDelete from "@/pages/modals/_delete";
import { useDeleteRentalMutation } from "@/services/rental.service";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

export default function DeleteRental() {
    const {t} = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [deleteRental, {isSuccess}] = useDeleteRentalMutation()

    const onAccept = () => {
        deleteRental(location.state?.id || "")
    }

    useEffect(() => {
        if (isSuccess) {
            navigate(location, {state: {reload: true}})
        }
    }, [isSuccess])
    
    return <ModelDelete title={t("modal.delete_rental")} content={t("modal.delete_rental_content")} onAccept={onAccept} />
}